import { render, staticRenderFns } from "./Truck.vue?vue&type=template&id=71d435db&scoped=true"
import script from "./Truck.vue?vue&type=script&lang=js"
export * from "./Truck.vue?vue&type=script&lang=js"
import style0 from "./Truck.vue?vue&type=style&index=0&id=71d435db&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d435db",
  null
  
)

export default component.exports